// extracted by mini-css-extract-plugin
module.exports = {"block":"panel-module--block--2cIVt","title":"panel-module--title--3-TFp"};